import { useTranslation } from '../../../i18n/hooks';
import type { TrainingTranslation, TrainingCourse, EraFeature } from '../types';

export const useTrainingTranslation = () => {
  const { t, i18n } = useTranslation(['training']);

  const getTranslation = (): TrainingTranslation => {
    const courseCatalog = (t('courses', { returnObjects: true }) || {}) as Record<string, TrainingCourse>;
    const courseKeys = Object.keys(courseCatalog);

    const courses: Record<string, TrainingCourse> = {};
    for (const key of courseKeys) {
      courses[key] = {
        title: t(`courses.${key}.title`),
        duration: t(`courses.${key}.duration`),
        icon: t(`courses.${key}.icon`),
        level: t(`courses.${key}.level`),
        description: t(`courses.${key}.description`),
        prerequisites: t(`courses.${key}.prerequisites`, { returnObjects: true }),
        topics: t(`courses.${key}.topics`, { returnObjects: true }),
        includes: t(`courses.${key}.includes`, { returnObjects: true }),
      };
    }

    const eraFeatures: EraFeature[] = t('era.features', { returnObjects: true }) || [];

    return {
      title: t('title'),
      subtitle: t('subtitle'),
      tracks: {
        label: t('tracks.label'),
        description: t('tracks.description'),
      },
      courses,
      customTraining: {
        text: t('customTraining.text'),
        buttonText: t('customTraining.buttonText'),
      },
      era: {
        badge: t('era.badge'),
        title: t('era.title'),
        subtitle: t('era.subtitle'),
        features: eraFeatures,
      },
      request: {
        title: t('request.title'),
        subtitle: t('request.subtitle'),
        fields: t('request.fields', { returnObjects: true }),
        options: t('request.options', { returnObjects: true }),
        submit: t('request.submit'),
        cta: t('request.cta'),
        sending: t('request.sending'),
        success: t('request.success'),
        error: t('request.error'),
      },
    };
  };

  return {
    t,
    i18n,
    getTranslation,
  };
};
